<template>
  <dr-wrapper v-if="isInEditorMode" v-bind="$props" v-on="wrapOn">
    <drLogin v-bind="$props" :disabled="true" :class="evaluateClasses(classes)" />
  </dr-wrapper>
  <drLogin v-else v-bind="$props" :disabled="false" :class="evaluateClasses(classes)"></drLogin>
</template>

<script>
import drLogin from './dr-login-component'
import mixin from '../../mixins/base-mixin'
import inputMixin from '../../mixins/input-mixin'
export default {
  mixins: [mixin, inputMixin],
  components: {
    drLogin
  }
}
</script>

<style>

</style>
